"use client";
import {
  createContext,
  useContext,
  ReactNode,
  useEffect,
  useState,
} from "react";
import {
  getDataFromSessionStorage,
  saveDataToSessionStorage,
} from "./services/storageService";
import { getProfile } from "./redux/reducers/login";
import { useDispatch } from "react-redux";
import { saveAuthUser } from "./redux/reducers/authReducer";
interface AuthContextType {
  isAuthenticated: any;
}

const AuthContext = createContext<AuthContextType | undefined | null>(
  undefined
);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const [isAuthenticated, setAuthValue] = useState<any>(null);

  const checkAuthenticatedUser = () => {
    if (!getDataFromSessionStorage("access-token")) return null;
    else if (getDataFromSessionStorage("user-role"))
      return getDataFromSessionStorage("user-role");
    else {
      getProfile()
        .then((response) => {
          if (response) {
            saveDataToSessionStorage("user-role", response.data.role);
            dispatch(saveAuthUser(response.data));
          }
          return response.data.role;
        })
        .catch(() => {
          return null;
        });
    }
  };

  useEffect(() => {
    setAuthValue(checkAuthenticatedUser());
  }, []);

  const setFirebase = async () => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then(() => {})
        .catch((error: any) => {
          throw error;
        });
    }
  };

  useEffect(() => {
    setFirebase();
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
